'use client';

import React from 'react';
import { ShopifyStore } from 'lib/commerce/shopify/shopifyHelper';
import { FORWARDED_PARAM_KEYS } from 'components/shared/CustomLink';
import { getCookie } from 'utils/cookie';
import { useRegionLocale } from 'contexts/RegionLocaleContext';
const params = FORWARDED_PARAM_KEYS;

export const useForwardSearchParamsShopify = (
  defaultValues: Record<string, string> = {},
): ((url: string, product_type?: string, store?: ShopifyStore) => string) => {
  const { currency } = useRegionLocale();
  const [currentLocationSearch, setCurrentLocationSearch] = React.useState('');

  React.useEffect(() => {
    setCurrentLocationSearch(document.location.search);
  }, []);

  return (url: string, product_type?: string, store?: ShopifyStore) => {
    if (!url) return '';

    const newUrl = new URL(url);

    const linkSearchParams = new URLSearchParams();
    const documentSearchParams = new URLSearchParams(currentLocationSearch);

    for (const [k, v] of newUrl.searchParams) {
      linkSearchParams.set(k, v);
    }

    linkSearchParams.set('channel', 'buy_button');
    if (product_type)
      linkSearchParams.set('attributes[product_type]', product_type);

    Object.entries(defaultValues).forEach(([param, value]) => {
      linkSearchParams.set(param, value);
      const paramKey = `attributes[${param}]`;
      linkSearchParams.set(paramKey, value);
    });

    params.forEach((param) => {
      const value = documentSearchParams.get(param);
      let paramKey = `attributes[${param}]`;
      if (param === 'email') paramKey = `checkout[email]`;
      if (param === 'discount') paramKey = 'discount';
      if (value) {
        linkSearchParams.set(paramKey, value);
      }
    });

    // Read Meta attribution cookies for CAPI event matching
    try {
      const fbclid = getCookie('_uh_fbclid');
      if (fbclid) {
        linkSearchParams.set('fbclid', String(fbclid));
        linkSearchParams.set('attributes[fbclid]', String(fbclid));
      }
      const fbp = getCookie('_fbp');
      if (fbp) {
        linkSearchParams.set('_fbp', String(fbp));
        linkSearchParams.set('attributes[_fbp]', String(fbp));
      }
      // getCookie() does not decode, but the value is written encoded.
      const rdtCid = getCookie('_uh_rdt_cid');
      if (rdtCid) {
        const decoded = decodeURIComponent(String(rdtCid));
        linkSearchParams.set('rdt_cid', decoded);
        linkSearchParams.set('attributes[rdt_cid]', decoded);
      }
    } catch (_) {
      // cookie read may fail in SSR or with restricted permissions
    }

    // add base currency -
    if (store && currency) linkSearchParams.set('currency', currency);

    if (!newUrl.hostname.includes('stripe.com')) {
      linkSearchParams.set('skip_shop_pay', 'true');
    }

    newUrl.search = linkSearchParams.toString();
    return newUrl.href;
  };
};
